import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import { useReportContext } from "../../../_context/ReportContext";
import "../../Admin/AddUsers/AddUsers.css";
import "../Reports.css";

const NDISQuestions: React.FC = () => {
  const { newReport, setNewReport } = useReportContext();

  useEffect(() => {
    if (newReport.NDISIncidentOccurred === undefined || newReport.NDISPPEUsed === undefined) {
      setNewReport((prev) => ({
        ...prev,
        NDISIncidentOccurred: false,
        NDISPPEUsed: true,
        NDISIncidentDetails: "",
      }));
    }
  }, [newReport.NDISIncidentOccurred, newReport.NDISPPEUsed, setNewReport]);

  const handleIncidentChange = (value: boolean) => {
    setNewReport((prev) => ({
      ...prev,
      NDISIncidentOccurred: value,
      NDISIncidentDetails: value ? prev.NDISIncidentDetails : "",
    }));
  };

  const handlePPEChange = (value: boolean) => {
    setNewReport((prev) => ({ ...prev, NDISPPEUsed: value }));
  };

  return (
    <div className="reports-page-wrapper" style={{ maxWidth: 840 }}>
      {/* Header */}
      <div className="rp-client-header" style={{ background: "linear-gradient(135deg, #0f766e 0%, #0d9488 100%)" }}>
        <h2 className="rp-client-title">Step 3: NDIS Safety Questions</h2>
        <div className="rp-client-email">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          Required compliance items for NDIS jobs
        </div>
      </div>

      {/* Content */}
      <div className="au-card" style={{ marginBottom: 24 }}>
        <div className="au-card-body" style={{ padding: "32px 36px" }}>

          {/* Question 1 */}
          <div style={{ marginBottom: "40px" }}>
            <h5 style={{ fontWeight: 600, color: "#0f1c34", marginBottom: "16px", fontSize: "1.05rem" }}>
              1. Did any incidents occur during the cleaning?
            </h5>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
              <button
                style={{
                  padding: "16px",
                  borderRadius: "12px",
                  border: newReport.NDISIncidentOccurred === true ? "2px solid #dc2626" : "1px solid #E5E7EB",
                  background: newReport.NDISIncidentOccurred === true ? "rgba(220,38,38,0.05)" : "#fff",
                  color: newReport.NDISIncidentOccurred === true ? "#dc2626" : "#4B5563",
                  fontWeight: 700,
                  fontSize: "1.1rem",
                  cursor: "pointer",
                  transition: "all 0.2s"
                }}
                onClick={() => handleIncidentChange(true)}
              >
                YES
              </button>

              <button
                style={{
                  padding: "16px",
                  borderRadius: "12px",
                  border: newReport.NDISIncidentOccurred === false ? "2px solid #16a34a" : "1px solid #E5E7EB",
                  background: newReport.NDISIncidentOccurred === false ? "rgba(22,163,74,0.04)" : "#fff",
                  color: newReport.NDISIncidentOccurred === false ? "#16a34a" : "#4B5563",
                  fontWeight: 700,
                  fontSize: "1.1rem",
                  cursor: "pointer",
                  transition: "all 0.2s"
                }}
                onClick={() => handleIncidentChange(false)}
              >
                NO
              </button>
            </div>

            {newReport.NDISIncidentOccurred === true && (
              <div style={{ marginTop: "24px", animation: "auFadeIn 0.3s ease-out both" }}>
                <p style={{ fontWeight: 600, fontSize: "0.9rem", color: "#dc2626", marginBottom: "8px" }}>
                  Please provide details about the incident:
                </p>
                <div className="form-group-class">
                  <Form.Control
                    as="textarea"
                    rows={4}
                    style={{ height: "auto", minHeight: "100px", resize: "vertical" }}
                    value={newReport.NDISIncidentDetails || ""}
                    onChange={(e) => setNewReport(prev => ({ ...prev, NDISIncidentDetails: e.target.value }))}
                    placeholder="Describe what happened during the incident in detail..."
                  />
                </div>
              </div>
            )}
          </div>

          <div style={{ height: "1px", background: "#E5E7EB", margin: "0 -36px 36px -36px" }} />

          {/* Question 2 */}
          <div>
            <h5 style={{ fontWeight: 600, color: "#0f1c34", marginBottom: "16px", fontSize: "1.05rem" }}>
              2. Was the required PPE used by the staff member during the session?
            </h5>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
              <button
                style={{
                  padding: "16px",
                  borderRadius: "12px",
                  border: newReport.NDISPPEUsed === true ? "2px solid #16a34a" : "1px solid #E5E7EB",
                  background: newReport.NDISPPEUsed === true ? "rgba(22,163,74,0.04)" : "#fff",
                  color: newReport.NDISPPEUsed === true ? "#16a34a" : "#4B5563",
                  fontWeight: 700,
                  fontSize: "1.1rem",
                  cursor: "pointer",
                  transition: "all 0.2s"
                }}
                onClick={() => handlePPEChange(true)}
              >
                YES
              </button>

              <button
                style={{
                  padding: "16px",
                  borderRadius: "12px",
                  border: newReport.NDISPPEUsed === false ? "2px solid #dc2626" : "1px solid #E5E7EB",
                  background: newReport.NDISPPEUsed === false ? "rgba(220,38,38,0.05)" : "#fff",
                  color: newReport.NDISPPEUsed === false ? "#dc2626" : "#4B5563",
                  fontWeight: 700,
                  fontSize: "1.1rem",
                  cursor: "pointer",
                  transition: "all 0.2s"
                }}
                onClick={() => handlePPEChange(false)}
              >
                NO
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default NDISQuestions; 